<div class="row rs-xpandgrid">
  <div class="columns small-12 medium-8">
    <div class="rs-panel-big rs-bg-c2 clearfix rs-margin-bottom4-m">
      <div
        class="panel rs-h-s4 rs-margin-bottom3-m rs-wd-m35 rs-bg-skeleton rs-anim-loading"
      ></div>
      <div class="panel rs-h-s3 rs-wd-25 rs-bg-skeleton rs-anim-loading"></div>
      <div class="panel rs-h-s3 rs-wd-25 rs-bg-skeleton rs-anim-loading"></div>
      <hr />
      <div class="panel rs-h-s5 rs-wd-m12 rs-bg-skeleton rs-anim-loading"></div>
    </div>

    <div class="rs-panel-big rs-bg-c2 clearfix rs-margin-bottom4-m">
      <div
        class="panel rs-h-s4 rs-margin-bottom3-m rs-wd-m35 rs-bg-skeleton rs-anim-loading"
      ></div>
      <div class="panel rs-h-s12 rs-wd-25 rs-bg-skeleton rs-anim-loading"></div>
      <div class="panel rs-h-s5 rs-wd-m25 rs-bg-skeleton rs-anim-loading"></div>
    </div>
  </div>
  <div class="columns small-12 medium-4">
    <div class="rs-panel-big rs-bg-c2 clearfix">
      <div
        class="panel rs-h-s4 rs-margin-bottom3-m rs-bg-skeleton rs-anim-loading"
      ></div>
      <div class="panel rs-h-s5 rs-bg-skeleton rs-anim-loading"></div>
      <div class="panel rs-h-s22 rs-bg-skeleton rs-anim-loading"></div>
    </div>
  </div>
</div>
